import { PASSPORT_ROUTES } from "src/constants/routes";

type StepFields = {
  route: string;
  fields: string[];
};

// Ordered by step, so the earliest step with a failing field wins. Built lazily because
// PASSPORT_ROUTES is not yet initialised when this module is first imported (circular import).
const getStepFields = (): StepFields[] => [
  {
    route: PASSPORT_ROUTES.ownerInfo,
    fields: [
      "owner_nationality",
      "id_number",
      "nik",
      "id_name",
      "dob",
      "pob",
      "pob_others",
      "director_name",
      "selfie",
      "selfie_upload",
      "liveness_verified",
      "ktp_upload",
      "kitas_upload",
      "passport_upload",
    ],
  },
  {
    route: PASSPORT_ROUTES.businessInfo,
    fields: [
      "finance_email",
      "in_dev_url",
      "no_web_url",
      "outlet_address",
      "outlet_city",
      "physical_business_upload",
    ],
  },
  {
    route: PASSPORT_ROUTES.bankDetails,
    fields: [
      "bank_account",
      "account_no",
      "bank_code",
      "account_name",
      "bank_passbook_url",
    ],
  },
];

/**
 * Returns the route of the step owning the field named in a 400 validation error, if any.
 */
export const resolveStepFieldError = (error: any): string | undefined => {
  const response = error?.response;
  if (response?.status !== 400) return;

  const words = new Set(
    JSON.stringify(response.data ?? "")
      .toLowerCase()
      .match(/[a-z0-9_]+/g)
  );

  return getStepFields().find(({ fields }) =>
    fields.some((name) => words.has(name))
  )?.route;
};
